import React from "react";
import PropTypes from "prop-types";
import PaginationDot from "./PaginationDot";

const styles = {
  root: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
};

const DotPagination = ({ index, dots, onChangeIndex }) => {
  const handleClick = (_, activeIndex) => {
    onChangeIndex(activeIndex);
  };

  return (
    <div style={styles.root}>
      {Array.from({ length: dots }, (_, i) => i + 1).map((dot, i) => (
        <PaginationDot key={dot} index={i} active={i === index} onClick={handleClick} />
      ))}
    </div>
  );
};

DotPagination.propTypes = {
  dots: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  onChangeIndex: PropTypes.func.isRequired,
};

export default DotPagination;
